import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';
import { AuthShell } from '@/components/layout/AuthShell';
import { ResetPasswordForm } from '@/features/auth/ResetPasswordForm';
import { Alert } from '@/components/ui/Alert';

const searchSchema = z.object({
  token: z.string().min(1).optional(),
});

export const Route = createFileRoute('/reset-password')({
  validateSearch: searchSchema,
  component: ResetPasswordPage,
});

function ResetPasswordPage() {
  const { t } = useTranslation('auth');
  const { token } = Route.useSearch();
  return (
    <AuthShell title={t('reset.title')} subtitle={t('reset.subtitle')}>
      {token ? (
        <ResetPasswordForm token={token} />
      ) : (
        <Alert variant="warn" title={t('reset.missingTokenTitle')}>
          {t('reset.missingTokenBody')}
        </Alert>
      )}
    </AuthShell>
  );
}
